import React, { Component } from 'react';
import './AdminCourier.css';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminTableDetails from '../Components/AdminTableDetails/AdminTableDetails';
import AdminEditCourierData from '../Components/AdminEditCourierData/AdminEditCourierData';

import personsm from '../../../image/personsm.svg'
import axios from 'axios'
import { LinkAPI } from '../../../API/API'
import HandleRes from '../../Components/HandleRes/HandleRes';

class AdminCourier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            search:'',
 
            courier_id: '',
            online: '',
            title: '',
            balance: '',
            amount: '',
            doneEdit: false,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,

        }
        this.getcouriers = this.getcouriers.bind(this)
        this.getcouriers()
    }
    getcouriers = () => {
        const Token = localStorage.getItem("AdminTokenKayn")

        axios.get(`${LinkAPI}/api/admin/getcouriers`, {
            headers: {
                Authorization: `${Token}`,
                status:1
            }
        }).then(res => {
            this.setState({
                data: res.data.reverse(),
                networkError: false,
                errordatamessage: false,
                hasError: false,
            })
        }).catch(error => {
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                window.location.replace("/Admin/SignIn");
            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext: error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })
    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };
    setStateField = (object) => e => {
        this.setState({
            objectClient: object,
            courier_id: object._id,
            online: object.online,
            title: object.title,
            balance: object.balance,
            onlineError: "",
            titleError: ""
        })
    }
    handleType = event => {
        this.setState({
            title: event.target.value,
        })

    }
    handleOnline = () => {
        if (this.state.online === true) {
            this.setState({
                online: false,
            })
        } else {
            this.setState({
                online: true,
            })
        }
    }


    validate = () => {
        let onlineError = "";
        let titleError = "";


        if (this.state.title === 'pickup' || this.state.title === 'delivery') {

        } else {
            titleError = "choose Courier type";
        }
        if (this.state.online === true || this.state.online === false) {
        } else {
            onlineError = "wrong status  ";
        }
        if (onlineError || titleError) {
            this.setState({ onlineError, titleError });
            return false;
        }
        return true;
    };

    validateupdatecourierbalance = () => {
        let amountError = "";


        if (this.state.amount <= 0 || isNaN(this.state.amount)) {
            amountError = "wrong amount  ";
        }

        if (amountError) {
            this.setState({ amountError });
            return false;
        }
        return true;
    };
    editcourier = event => {
        event.preventDefault();
        const { courier_id, title, online } = this.state
        const Token = localStorage.getItem("AdminTokenKayn")
        const isValid = this.validate();
        if (isValid) {
            axios.put(`${LinkAPI}/api/admin/editcourier`, {
                courier_id: courier_id,
                update: {
                    title: title,
                    online: online
                }
            }, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
               
                this.setState({
                    doneEdit: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                    titleError: '',
                    onlineError: ''
                })
                this.getcouriers()
                setTimeout(() => {
                    this.setState({
                        doneEdit: false
                    })
                }, 2000);
            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    window.location.replace("/Admin/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        titleError: '',
                        onlineError: '',
                        errordatamessage: true,
                        errordatamessagetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
        }
    }
    updatecourierbalance = event => {
        event.preventDefault();
        const { courier_id, amount } = this.state
        const Token = localStorage.getItem("AdminTokenKayn")
        const isValid = this.validateupdatecourierbalance();
        if (isValid) {
            axios.put(`${LinkAPI}/api/admin/updatecourierbalance`, {
                courier_id: courier_id,
                amount: amount
            }, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
               
                this.setState({
                    balance: res.data.balance,
                    doneEdit: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                    amountError: '',
                })
                this.getcouriers()
                setTimeout(() => {
                    this.setState({
                        doneEdit: false
                    })
                }, 2000);
            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    window.location.replace("/Admin/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        amountError: '',
                        errordatamessage: true,
                        errordatamessagetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
        }
    }
    render() {
        const  filteredContantsname = this.state.data.filter(
            (contact)=>{
                return contact.name.toLowerCase().indexOf(this.state.search.toLowerCase())!==-1;
            }
        )
        const itemdatatabel = filteredContantsname.map((x, i) => {
            return <div className="p-3 border-bottom item-table pointer" onClick={this.setStateField(x)}>

                <a ><img className="mr-3" src={personsm} alt="user kayn" /><span>{x.name}</span></a>
            </div>
        })
        return (
            <div>
                <div className="row AppEN  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarAdmin />
                    </div>
                    <div className=" AdminCourierCreate Admin col-md-11 px-4">
                        <AdminHeaderTool />
                        <div className="row">
                            <h3 className="col-12 fontsize9 my-0 order-8 order-md-2" >Couriers</h3>

                            <div className="col-md-4 px-2 py-3 order-8 order-md-2">
                                <AdminTableDetails itemdatatabel={itemdatatabel} state={this.state} handleChange={this.handleChange} />

                            </div>
                            <div className="col-md-8 px-4 py-3 order-5">
                                <div className="picbg">
                                    {(this.state.objectClient ?
                                        <AdminEditCourierData state={this.state} handleType={this.handleType} handleChange={this.handleChange} handleOnline={this.handleOnline} editcourier={this.editcourier} updatecourierbalance={this.updatecourierbalance} />
                                        :
                                        <div className="picbg">
                                            <p className="text-center fontsize4">No Courier selected</p>
                                        </div>)}

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {(this.state.doneEdit ? <HandleRes title="Information has been changed" stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default AdminCourier;